/* eslint-disable jsx-a11y/img-redundant-alt */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TextField, Typography, Box, Grid } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken') || window.localStorage.getItem('webViewToken')}`,
        'Content-Type': 'application/json'
    }
};
const LabelledField = ({ label, children }) => (
    <Box
        mb={2}
        sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { sm: 'center' },
            gap: 2
        }}
    >
        <Typography sx={{ width: { xs: '100%', sm: '200px' }, fontWeight: 'bold', fontSize: '14px' }}>{label}</Typography>
        {children}
    </Box>
);

const CustomTextField = (props) => (
    <TextField
        fullWidth
        size="small"
        variant="outlined"
        sx={{
            bgcolor: 'rgba(255,255,255,0.8)',
            '& .MuiOutlinedInput-root': {
                borderRadius: 0,
                '& fieldset': {
                    borderRadius: 0,
                    borderColor: '#4a2a82'
                },
                '&:hover fieldset': {
                    borderRadius: 0,
                    borderColor: '#4a2a82'
                },
                '&.Mui-focused fieldset': {
                    borderRadius: 0,
                    borderColor: '#4a2a82'
                }
            }
        }}
        {...props}
    />
);
const IdCard = () => {
    const [signature, setSignature] = useState('');
    const location = useLocation();
    const studentData = location.state?.studentData;
    const formatAddress = (data) => {
        const { houseNo, street, district, city, state, zip, country } = data;
        const parts = [];

        if (houseNo?.trim()) parts.push(`House No. ${houseNo.trim()}`);
        parts.push(
            street.trim(),
            district.trim().toLowerCase() !== city.trim().toLowerCase() ? district.trim() : null,
            city.trim(),
            state.trim(),
            zip.trim(),
            country.trim()
        );

        return parts.filter(Boolean).join(', ');
    };
    const permanentAddress = formatAddress(studentData?.permanentAddress);
    const fetchSignature = async (fileName) => {
        axios.post(`/v1/utils/file/download`, { fileName }, headers).then((result) => {
            setSignature(result.data.data);
        });
    };
    useEffect(() => {
        if (studentData?.studentSignature || studentData?.declarations[0]?.signatureFile)
            fetchSignature(studentData.studentSignature || studentData?.declarations[0]?.signatureFile);
    }, []);
    return (
        <MainCard>
            <Box
                sx={{
                    fontFamily: 'Arial, sans-serif',
                    maxWidth: '800px',
                    margin: '0 auto',
                    padding: '20px',
                    background: '#E8EBF2',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                        marginBottom: '20px',
                        borderBottom: '2px solid #1a3c7e'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '16px',

                            backgroundColor: '#E8EBF2'
                        }}
                    >
                        <img src="/UniversityHeader.png" alt="University Header" style={{ maxWidth: '100%', height: 'auto' }} />
                    </Box>
                    <h2
                        style={{
                            fontSize: '18px',
                            color: '#1a3c7e',
                            marginTop: '10px',
                            marginBottom: '15px'
                        }}
                    >
                        Data Collection Form for ID Card
                    </h2>
                </Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2, mb: 2 }}>
                    Fill up the Following Details (Use Capital Letters)
                </Typography>
                <LabelledField label="1) Name of Student:">
                    <CustomTextField name="studentName" value={studentData?.studentName} />
                </LabelledField>
                <LabelledField label="2) Enrollment No:">
                    <CustomTextField name="enrollmentNo" value={studentData?.enrollmentNo} />
                </LabelledField>
                <LabelledField label="3) Roll No:">
                    <CustomTextField name="rollNo" value={studentData?.rollNo} />
                </LabelledField>
                <LabelledField label="4) Program:">
                    <CustomTextField name="course" value={studentData?.courseDetail?.course?.courseName} />
                </LabelledField>
                <LabelledField label="5) Address:">
                    <CustomTextField name="address" value={permanentAddress} />
                </LabelledField>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="City:">
                            <CustomTextField name="city" value={studentData?.permanentAddress?.city} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="District:">
                            <CustomTextField name="district" value={studentData?.permanentAddress?.district} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="State:">
                            <CustomTextField name="state" value={studentData?.permanentAddress?.state} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="Pin:">
                            <CustomTextField name="pin" value={studentData?.permanentAddress?.pin} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="6) Date of Birth:">
                            <CustomTextField name="dob" value={studentData?.personalDetails?.dob} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="7) Blood Group:">
                            <CustomTextField name="dob" value={studentData?.personalDetails?.bloodGroup} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="8) ID Mark:">
                            <CustomTextField name="dob" value={studentData?.personalDetails?.idMark} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="9) Contact No.:">
                            <CustomTextField name="dob" value={studentData?.personalDetails?.phone} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="Student Photo">
                            <Box
                                sx={{
                                    width: '200px',
                                    height: 'auto',
                                    border: '1px solid #1a3c7e',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '5px',
                                    overflow: 'hidden'
                                }}
                            >
                                {studentData?.studentPhoto ? (
                                    <img
                                        src={studentData.studentPhoto}
                                        alt="Student Photo"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover',
                                            borderRadius: 4
                                        }}
                                    />
                                ) : (
                                    <Typography fontSize="0.85rem" textAlign="center" fontWeight="bold">
                                        Affix latest <br /> passport size <br /> photograph
                                    </Typography>
                                )}
                            </Box>
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <LabelledField label="Signature of Student">
                            {(studentData?.studentSignature || studentData?.declarations[0]?.signatureFile) && (
                                <Box display="flex" mb={1}>
                                    <img
                                        src={signature}
                                        alt="Student Signature"
                                        style={{
                                            maxWidth: '100%',
                                            width: '200px',
                                            border: '1px solid #1a3c7e',
                                            borderRadius: 4
                                        }}
                                    />
                                </Box>
                            )}
                        </LabelledField>
                    </Grid>
                </Grid>
            </Box>
        </MainCard>
    );
};

export default IdCard;
